<!-- Ported from the Polaris kit: src/components/ui/item/ItemDescription.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <p
    data-slot="item-description"
    :class="
      cn(
        'text-polaris-muted-foreground line-clamp-2 type-polaris-body leading-normal font-normal text-balance',
        '[&>a:hover]:text-polaris-primary [&>a]:underline [&>a]:underline-offset-4',
        props.class
      )
    "
  >
    <slot />
  </p>
</template>
